exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".rating-control {\n  display: inline-block;\n  max-width: 100px; }\n\n.rating-stars {\n  display: inline-block;\n  margin-left: 20px; }\n  .rating-stars .fa-star.shine {\n    color: darkorange; }\n  .rating-stars .fa-star {\n    color: darkgray; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?{"includePaths":["/root/src/ui","/root/src/ui/node_modules"]}!./~/import-glob-loader!./app/common/forms/rating-control.component.sass
// module id = 1097
// module chunks = 4